<template>
    <h2 class="mt-4 pt-5 pb-4 text-2xl text-[#545656]">
        <router-link :to="props.link ? props.link : ''" class="hover:text-[#db0720]">
            <span class="font-semibold"> {{ props.title }} </span> - Management Tool 2.0
        </router-link>
    </h2>
</template>

<script lang="ts" setup>
    const props = defineProps({
        title: String,
        link: String,
    })
</script>
